<p>report-search-invoice works!</p>
